export const SUBJECT_PROPERTY_MODEL_KEYS = {
  address: "address",
  purchasePrice: "purchasePrice",
  asIsValue: "asIsValue",
  constructionBudget: "constructionBudget",
  propertyType: "propertyType",
  purchaseDate: "purchaseDate",
  totalMonthlyRent: "totalMonthlyRent", // is this calculated
  annualTaxes: "annualTaxes",
  annualInsurance: "annualInsurance",
  annualHoaFees: "annualHoaFees",
  arv: "arv",
  expectedClosingDate: "expectedClosingDate", // date
  additionalBasis: "additionalBasis", // dollar

  // NEW FIELDS NOT YET ADDED TO OFFICIAL MODEL
  hasSqftAddedOrUseChanged: "hasSqftAddedOrUseChanged", // boolean
  hasApprovedPlansAndPermits: "hasApprovedPlansAndPermits", // boolean
  refinanceType: "refinanceType", // select || ["Cash Out", "Rate and Term"]
  requestedLoanTermMonths: "requestedLoanTermMonths", // select || ["6 months", "12 months", "18 months", "24 months"]
};
